import { fetchDataPutReq } from '../apis/apiUtil';
export function getAllNotificationsCount(data, url) {
    return fetchDataPutReq(url, data);
}
export function getVendorPortalNotificationList(data, url) {
    return fetchDataPutReq(url, data);
}
